import * as React from "react";
import { clsx } from "clsx";
import { useAnalyticsTrigger } from "../helpers/analytics/use-analytics-trigger.mjs";
import { Anchor } from "../typography/anchor/anchor.mjs";
const ButtonNavigation = (props) => {
  const { align = "center", elementRef, behaviour, items, purpose = "default", size, className } = props;
  return /* @__PURE__ */ React.createElement(
    "ul",
    {
      className: clsx(
        "btn-nav",
        {
          ["btn-nav--size-".concat(size)]: !!size,
          ["btn-nav--align-".concat(align)]: !!align
        },
        className
      ),
      ref: elementRef,
      role: behaviour === "tabs" ? "tablist" : "list",
      "aria-labelledby": props["aria-labelledby"]
    },
    items.map((item, index) => {
      var _a, _b;
      return /* @__PURE__ */ React.createElement(ButtonNavigationItem, { ...item, key: (_a = item.id) != null ? _a : index, purpose: (_b = item.purpose) != null ? _b : purpose, behaviour });
    })
  );
};
const ButtonNavigationItem = (props) => {
  const { id, label, current, purpose, behaviour = "list", onClick: onClickProp, ...rest } = props;
  const BEM = () => {
    const classArray = ["btn-nav__item", "btn-nav__item--purpose-".concat(purpose)];
    if (current) {
      classArray.push("is-current");
    }
    return classArray.join(" ");
  };
  const triggerId = id != null ? id : label;
  const { onClick } = useAnalyticsTrigger(
    {
      callback: "onClick",
      id: triggerId,
      elementId: triggerId,
      elementType: "link"
    },
    { onClick: onClickProp }
  );
  return /* @__PURE__ */ React.createElement("li", { className: BEM(), id, role: behaviour === "tabs" ? "presentation" : void 0 }, /* @__PURE__ */ React.createElement(Anchor, { isUnderlined: false, "aria-current": behaviour === "list" && current ? "true" : void 0, ...rest, onClick, className: "btn-nav__link" }, label));
};
export {
  ButtonNavigation
};
